import React, { useEffect, useState } from 'react';
import '../assets/css/WhoweAre.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { GrVmMaintenance } from "react-icons/gr";
import { SiAntdesign } from "react-icons/si";
import { BiStreetView } from "react-icons/bi";
import { TfiSplitVAlt } from "react-icons/tfi";
import whowe from '../assets/images/who-we.avif';

const WhoweAre = () => {
  const [hoveredCard, setHoveredCard] = useState(null);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
    });
  }, []);

  const features = [
    {
      icon: <TfiSplitVAlt className="h4 mb-0" />,
      title: "Responsive Design",
      description: "Pixel-perfect designs that work seamlessly across all devices",
      delay: 0
    },
    {
      icon: <GrVmMaintenance className="h4 mb-0" />,
      title: "Maintenance",
      description: "Ongoing support to keep your systems running smoothly",
      delay: 100
    },
    {
      icon: <BiStreetView className="h4 mb-0" />,
      title: "Support",
      description: "24/7 dedicated support team for all your technical needs",
      delay: 200
    },
    {
      icon: <SiAntdesign className="h4 mb-0" />,
      title: "Development",
      description: "Custom solutions built with cutting-edge technologies",
      delay: 300
    }
  ];

  return (
    <div className="whoweare-enhanced">
      <div className="container">
        <div className="row align-items-center py-2">
          {/* Text Section */}
          <div className="col-lg-6 col-md-6 col-12 order-1 order-md-1" data-aos="fade-right">
            <div className="section-title ml-lg-5">
              <div className="title-wrapper">
                <h3 className="whoweheading">Who we are</h3>
                <div className="title-underline"></div>
              </div>
              <p className="font-weight-normal who-para" data-aos="fade-up" data-aos-delay="200">
                We're a passionate team of tech experts dedicated to delivering innovative software solutions. 
                From web and app development to AI and design, we help businesses thrive in the digital age. 
                With a focus on quality, creativity, and collaboration, we're here to turn your ideas into 
                impactful, real-world solutions.
              </p>

              {/* Enhanced Features Grid */}
              <div className="row">
                {features.map((feature, index) => (
                  <div 
                    key={index}
                    className="col-lg-6 col-md-6 col-sm-12 mt-4 pt-2"
                    data-aos="zoom-in"
                    data-aos-delay={feature.delay}
                  >
                    <div 
                      className={`feature-card media align-items-center rounded shadow p-4 ${
                        hoveredCard === index ? 'hovered' : ''
                      }`}
                      style={{ cursor: 'pointer' }}
                      onMouseEnter={() => setHoveredCard(index)}
                      onMouseLeave={() => setHoveredCard(null)}
                    >
                      <div className="feature-content">
                        <h6 className="mb-2">
                          <a href="#!" className="text-decoration-none feature-link">
                            {feature.title}
                          </a>
                        </h6>
                        <p className="feature-description mb-0">
                          {feature.description}
                        </p>
                      </div>
                      <div className="hover-indicator"></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Image Section */}
          <div className="col-lg-6 col-md-6 order-2 order-md-2 pt-2 mt-sm-0 opt-sm-0" data-aos="fade-left">
            <div className="image-container">
              <img
                src={whowe}
                alt="who-we-are"
                className="main-image img-fluid"
              />
              <div className="floating-elements">
                <div className="floating-element element-1" data-aos="fade-down" data-aos-delay="300">
                  <div className="element-icon">🚀</div>
                  <span>Innovation</span>
                </div>
                <div className="floating-element element-2" data-aos="fade-up" data-aos-delay="500">
                  <div className="element-icon">💡</div>
                  <span>Creativity</span>
                </div>
                <div className="floating-element element-3" data-aos="fade-right" data-aos-delay="700">
                  <div className="element-icon">⭐</div>
                  <span>Excellence</span>
                </div>
              </div>
              <div className="image-overlay"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhoweAre;